import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var SolardashboardService = /** @class */ (function () {
    function SolardashboardService(http) {
        this.http = http;
    }
    SolardashboardService.prototype.addupdateSolarManager = function (data) {
        return this.http.post("addUpdateSolarManager", data);
    };
    SolardashboardService.prototype.getSolarMagaer = function (roleid, userid, module) {
        return this.http.get("getSolarManagerData?roleid=" + roleid + "&userid=" + userid + "&module=" + module);
    };
    SolardashboardService.prototype.getSolarManagerData = function (data) {
        return this.http.post("getSolarManagerData", data);
    };
    SolardashboardService.prototype.deletSolarManager = function (data) {
        return this.http.delete("deleteSolarManager", {
            params: {
                serialNo: data.serialNo,
                deviceId: data.device_id
            }
        });
    };
    SolardashboardService.prototype.getSolarAssetId = function (data) {
        return this.http.post("getSolarAssetId", data);
    };
    SolardashboardService.prototype.getGeneration = function (data) {
        return this.http.post("getGenerationData", data);
    };
    SolardashboardService.prototype.getGenerationPerAsset = function (data) {
        return this.http.post("getGenerationPerAsset", data);
    };
    SolardashboardService.prototype.generationGraph = function (data) {
        return this.http.post("getDailyGeneration", data);
    };
    SolardashboardService.prototype.generationGraphWeekly = function (data) {
        return this.http.post("getWeeklyGeneration", data);
    };
    SolardashboardService.prototype.generationGraphMonthly = function (data) {
        return this.http.post("getMonthlyGeneration", data);
    };
    SolardashboardService.prototype.getWeatherData = function (data) {
        return this.http.post("getWeatherData", data);
    };
    SolardashboardService.prototype.getCalenderData = function (data) {
        return this.http.post("getCalenderData", data);
    };
    SolardashboardService.prototype.getDeviceStatus = function (data) {
        return this.http.post("getLastData", data);
    };
    SolardashboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SolardashboardService_Factory() { return new SolardashboardService(i0.ɵɵinject(i1.HttpClient)); }, token: SolardashboardService, providedIn: "root" });
    return SolardashboardService;
}());
export { SolardashboardService };
